import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Icon } from "@azim-crm/icons";
import styles from "./Segmented.module.css";
/**
 * Controle segmentado do Azim CRM (view switcher, filtros rápidos).
 *
 * Padrão ARIA radiogroup:
 * - container: role="radiogroup"
 * - opções:    role="radio" com roving tabindex
 * - navegação: ArrowLeft/ArrowRight movem foco e selecionam; Home/End saltam para as extremidades
 */
export function Segmented({ options, value, onChange, size = "md", "aria-label": ariaLabel }) {
    const groupRef = useRef(null);
    const activeIndex = options.findIndex((o) => o.value === value);
    const focusOption = (index) => {
        const group = groupRef.current;
        if (!group)
            return;
        const buttons = group.querySelectorAll("[role='radio']");
        buttons[index]?.focus();
    };
    const handleKeyDown = (e) => {
        const total = options.length;
        if (total === 0)
            return;
        let nextIndex = null;
        switch (e.key) {
            case "ArrowRight":
            case "ArrowDown":
                e.preventDefault();
                nextIndex = (activeIndex + 1) % total;
                break;
            case "ArrowLeft":
            case "ArrowUp":
                e.preventDefault();
                nextIndex = (activeIndex - 1 + total) % total;
                break;
            case "Home":
                e.preventDefault();
                nextIndex = 0;
                break;
            case "End":
                e.preventDefault();
                nextIndex = total - 1;
                break;
            default:
                return;
        }
        if (nextIndex !== null) {
            const nextOption = options[nextIndex];
            if (nextOption) {
                onChange(nextOption.value);
                // Foco imediato via RAF para garantir que o React já re-renderizou o tabIndex
                const idx = nextIndex;
                requestAnimationFrame(() => focusOption(idx));
            }
        }
    };
    return (_jsx("div", { ref: groupRef, role: "radiogroup", "aria-label": ariaLabel ?? "Opções", className: styles.root, onKeyDown: handleKeyDown, children: options.map((opt, index) => {
            const isActive = opt.value === value;
            return (_jsxs("button", { type: "button", role: "radio", "aria-checked": isActive, title: opt.label, tabIndex: isActive ? 0 : -1, onClick: () => onChange(opt.value), className: [
                    styles.option,
                    styles[size],
                    isActive ? styles.optionActive : "",
                ]
                    .filter(Boolean)
                    .join(" "), children: [opt.icon && _jsx(Icon, { name: opt.icon, size: 15 }), opt.label && _jsx("span", { children: opt.label })] }, opt.value));
        }) }));
}
//# sourceMappingURL=Segmented.js.map